import type { CosignatureStatus } from "@/core/types";

export function isStatusSettled(status: CosignatureStatus): boolean {
  return ["signed", "rejected"].includes(status);
}
